import {register} from '@shopify/theme-sections';

export default register('video-text', {
  onLoad() {
    const videos = this.container.querySelectorAll('video');
    if (videos && videos.length > 0) {
      videos.forEach((video) => {
        const parentEl = video.parentElement.querySelector('.video-controls');
        if (parentEl) {
          const pauseButton = parentEl.querySelector('.video-controls__pause');
          const playButton = parentEl.querySelector('.video-controls__play');
          const videoWrapper = video.parentElement;
          const soundToggle = videoWrapper.querySelector('.btn--sound-toggle');

          if (soundToggle) {
            soundToggle.addEventListener('click', () => {
              soundToggle.classList.toggle('is-muted');
              if (video.muted === true) {
                video.muted = false;
              } else if (video.muted === false) {
                video.muted = true;
              }
            });
          }

          video.addEventListener('click', () => {
            if (video.paused) {
              video.play();
              pauseButton.style.display = 'flex';
              playButton.style.display = 'none';
            } else {
              video.pause();
              pauseButton.style.display = 'none';
              playButton.style.display = 'flex';
            }
          });
        }
      });
    }
  },
});
